"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.terminateEmployee = void 0;
const role_delete_1 = __importDefault(require("@app/request/role-delete"));
const util_1 = require("@app/util");
const create_ac_1 = require("./util/create-ac");
const set_employees_1 = __importDefault(require("@app/action/set-employees"));
const set_modal_1 = __importDefault(require("./set-modal"));
const request_1 = require("@app/request");
const user_details_1 = require("@app/reducer/user-details");
const moment_1 = __importDefault(require("moment"));
exports.terminateEmployee = (0, create_ac_1.createAC)(async (dispatch, { endNow, workspaceId, userId, employees, deleteDate }) => {
    if ((0, util_1.isDefined)(endNow) && endNow) {
        await (0, role_delete_1.default)({
            workspace: workspaceId,
            user: userId,
        });
        const newEmployees = { ...employees };
        newEmployees[userId] = {
            ...newEmployees[userId],
            external: true,
        };
        dispatch((0, set_employees_1.default)(newEmployees));
        await dispatch((0, set_modal_1.default)(null));
        return;
    }
    if ((0, util_1.isDefined)(endNow) && !endNow) {
        const res = await (0, request_1.requestRoleUpdate)({
            workspace: workspaceId,
            user: userId,
            data: {
                terminateDate: deleteDate,
            },
        });
        if ((0, util_1.isDefined)(res)) {
            dispatch((0, user_details_1.setRoleTerminateDate)((0, moment_1.default)(deleteDate, 'YYYY-MM-DD').toDate()));
        }
    }
});
